import { render } from "./ProfileRelationContent.vue?vue&type=template&id=21773e1b&scoped=true"
import script from "./ProfileRelationContent.vue?vue&type=script&lang=js"
export * from "./ProfileRelationContent.vue?vue&type=script&lang=js"

import "./ProfileRelationContent.vue?vue&type=style&index=0&id=21773e1b&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21773e1b"]])

export default __exports__